import React from "react";
import { ChefHat, Utensils, Wheat, Paintbrush, Users, Rocket } from "lucide-react";

const ICONS = [ChefHat, Utensils, Wheat, Paintbrush, Users, Rocket];

export default function Turnkey({ t }) {
  return (
    <section id="model" className="relative py-24 md:py-32 bg-stone-base" data-testid="turnkey-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight">{t.title}</h2>
            <p className="mt-6 text-stone-300 text-base md:text-lg leading-relaxed max-w-md">{t.sub}</p>

            <div className="mt-10 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-amber-600/10 border border-amber-600/30">
              <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
              <span className="text-amber-400 text-xs uppercase tracking-[0.2em]">100% Turnkey Setup</span>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {t.items.map((item, i) => {
              const Icon = ICONS[i] || Rocket;
              return (
                <div key={i} className="heritage-card p-6 group" data-testid={`turnkey-item-${i}`}>
                  <div className="w-11 h-11 rounded-xl bg-stone-950 border border-amber-600/30 flex items-center justify-center text-amber-500 group-hover:bg-amber-600 group-hover:text-stone-950 transition-colors">
                    <Icon size={20} />
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-stone-50">{item.t}</h3>
                  <p className="mt-2 text-stone-400 text-sm leading-relaxed">{item.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
